import { FilterSelect } from '@/components/ui/list-filters';
import { CompanyProfileFilters } from '@/features/crm/companies/components/CompanyProfileFilters';
import { useIcpSegments } from '@/features/crm/icpSegments';
import { COUNTRIES } from '@/lib/countries';
import { ICP_FITS } from '../constants';
import type { LeadQualificationFilterValues } from '../qualificationFilters';

const COUNTRY_OPTIONS = COUNTRIES.map((c) => ({ value: c.code, label: c.name }));
const FIT_OPTIONS = [...ICP_FITS, { value: 'none', label: 'Not assessed' }];

/** Qualification rows for the Leads Filters popover (ADR-108). */
export function LeadQualificationFilters({
  value,
  onChange,
}: {
  value: LeadQualificationFilterValues;
  onChange: (next: LeadQualificationFilterValues) => void;
}) {
  const segments = useIcpSegments();
  const segmentOptions = [
    ...(segments.data?.results ?? []).map((s) => ({ value: String(s.id), label: s.name })),
    { value: 'none', label: 'No segment' },
  ];
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <FilterSelect
          label="ICP fit"
          value={value.icpFit}
          onChange={(icpFit) => onChange({ ...value, icpFit })}
          allLabel="Any fit"
          options={FIT_OPTIONS}
        />
        <FilterSelect
          label="ICP segment"
          value={value.icpSegment}
          onChange={(icpSegment) => onChange({ ...value, icpSegment })}
          allLabel="Any segment"
          options={segmentOptions}
        />
      </div>
      <CompanyProfileFilters value={value} onChange={(profile) => onChange({ ...value, ...profile })} />
      <FilterSelect
        label="Country"
        value={value.country}
        onChange={(country) => onChange({ ...value, country })}
        allLabel="Any country"
        options={COUNTRY_OPTIONS}
      />
    </>
  );
}
